export const defaultSentenceTruncator = (
    units,
    text,
    truncateWithLink = false
) => {
    if (!text || !text?.length) {
        return '';
    }
    const sentences = text.split('.');
    if (sentences.length < 1 || sentences.length < units || units < 1) {
        return text;
    }

    let concat = '';
    for (let i = 0; i < units; i += 1) {
        const sentenceToAdd =
            sentences[i] && sentences[i].length ? `${sentences[i]}` : '';
        concat += sentenceToAdd;
    }
    return `${concat.trim()}${truncateWithLink ? '' : '...'}`;
};

export const defaultCharacterTruncator = (
    units,
    text,
    truncateWithLink = false
) => {
    if (text.length > units && units > 0) {
        return `${text.substr(0, units)}${truncateWithLink ? '' : '...'}`;
    }

    return text;
};

export const ContentSnipper = ({
    children,
    sentences,
    characters,
    injectedSentenceTruncator,
    injectedCharacterTruncator,
    truncateWithLink,
}) => {
    const sentenceTruncator =
        injectedSentenceTruncator || defaultSentenceTruncator;
    const characterTruncator =
        injectedCharacterTruncator || defaultCharacterTruncator;
    let processedChildren = sentenceTruncator(
        sentences,
        children,
        truncateWithLink
    );
    processedChildren = characterTruncator(
        characters,
        processedChildren,
        truncateWithLink
    );
    return processedChildren;
};

export default ContentSnipper;
